// extracted by mini-css-extract-plugin
export default {"root":"MegaMenu_root__WD5Cz","megaMenu":"MegaMenu_megaMenu__fkPTu"};